import React, { forwardRef } from 'react';
import "./Switch.css";

const Switch = forwardRef((props, ref) => {
  /*** States and Variables ***/
  /*** Processing ***/
  /*** Sub Components ***/
  /*** Event Handlers ***/
  /*** Main Render ***/
  return <label className='switch_container'>
    <input
      type="checkbox"
      className='switch_checkbox'
      {...props}
      ref={ref}
      checked={props.value}
    />
    <span
      className='switch_slider' />
  </label>;
})
export default Switch;